// extracted by mini-css-extract-plugin
export default {"unclaimedLearnMoreModal":"unclaimedLearnMoreModal__Nzc5N","heading":"heading__MzQzO","favoriteButton":"favoriteButton__NjhhZ"};